module.exports = __webpack_public_path__ + "media/src/Checkout/Images/Icons/type_rv_site-993b2d77b17ef08ef9e11b57ce2dbe1355dc1cec9979ff284ce29f62173bfd65.svg";